import React, {useContext, useMemo, useRef, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import Button from "../../../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../../../utils/mask.js";
import GenericEditRemoveCellRenderer from "../../../../../../components/ag-grid/generic-edit-remove-cell-renderer.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import {v4} from "uuid";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import citizenAlertMessages from "../../utils/citizen-alert-messages.js";
import {CitizenContext} from "../context/citizen-context.jsx";

const CitizenContacts = () => {
    const {citizen, setCitizen} = useContext(CitizenContext);

    const [open, setOpen] = useState(false);
    const [phone, setPhone] = useState("");
    const [description, setDescription] = useState("");
    const [targetContact, setTargetContact] = useState(undefined);

    const gridRef = useRef(undefined);

    const defaultColDef = useMemo(() => ({
        comparator: aggridUtils.nullLastComparator
    }), []);

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    const addContact = () => {
        setPhone("");
        setDescription("");
        setOpen(true);
        setTargetContact(undefined)
    };

    const upsertContact = (newContact) => {
        if (!phone) {
            projectUtils.swalErrorMessage("", citizenAlertMessages["missing.contact.phone"], "Ok");
            return;
        }

        const updated = newContact ?
            [...citizen.contactPhones, {id: v4(), phone, description}] :
            citizen.contactPhones.map((c) => c.id === targetContact ? {phone, description} : c);

        setCitizen(prev => ({...prev, contactPhones: updated}));
        setOpen(false);
    }

    const removeContact =(contact) => {
        const updated = gridRef.current.props.rowData.filter((i) => i.id !== contact.id);
        setCitizen(prev => ({...prev, contactPhones: updated}));
    }

    const handleData = (data) => {
        setPhone(data?.phone);
        setDescription(data?.description);
        setTargetContact(data?.id);
    }

    const [columnDefs,] = useState([
        {field: "phone", headerName: "Telefone", flex: 1, valueFormatter: ({value}) => projectUtils.formatPhone(value)},
        {field: "description", headerName: "Descrição", flex: 2},
        {
            headerName: "",
            field: "",
            width: 100,
            cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {setData: handleData, setOpen, remove: removeContact}
        },
    ]);

    return (
        <>
            <Card>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Contatos</Card.Title>

                    <Button onClick={addContact}>
                        <FaPlus />
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className={"ag-theme-quartz grid h-[calc(100vh-200px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowHeight={35}
                            rowData={citizen?.contactPhones ?? []}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            paginationAutoPageSize={true}
                            pagination={true}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={theme}
                        />
                    </div>
                </Card.Body>
            </Card>

            <Modal open={open} setOpen={setOpen} title={"Contato do protegido"} className={"w-2xl"}>
                <Modal.Body className={"!mt-0 p-4 grid grid-cols-12 gap-4"}>
                    <InputForm
                        id={"phone"}
                        value={phone}
                        mask={MaskDefault.phone}
                        label={"Telefone *"}
                        classNameWrapper={"col-span-4"}
                        onChange={({target}) => setPhone(target.value)}
                    />
                    <InputForm
                        id={"description"}
                        value={description}
                        label={"Descrição"}
                        classNameWrapper={"col-span-8"}
                        onChange={({target}) => setDescription(target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button target={"primary"} onClick={() => upsertContact(!targetContact)}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CitizenContacts;